<lf-general-dialog-layout class="fileset-local-import">
    <div class="dialog-content">
        <div *ngIf="isLoading" class="loading-spinner-container">
            <img class="loading-spinner" src="//lfxstatic.com/img/general/loading-spinner.gif" alt="Loading...">
        </div>
        <iframe #importIframe [ngClass]="{'hide-iframe': isLoading }" [src]="url" frameborder="0" allowfullscreen></iframe>
    </div>
</lf-general-dialog-layout>